<template>
<Teleport to="body">
  <div class="fixed inset-0 z-50 overflow-y-auto bg-black/60 flex justify-center p-2 sm:p-5" @click.self="closeDialog(false)">
    <div class="w-full md:w-8/12 lg:w-6/12 my-auto" @click.self="closeDialog(false)" >

      <div class="p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center">
        
        <div class="flex flex-col w-full text-black">
        
          <BlockUI :visible="blocked">

            <div v-if="blocked" class="absolute inset-0 flex items-center justify-center z-50 bg-black/20">
              <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="5" fill="transparent" animationDuration=".5s" />
            </div>

            <div class="flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r from-[#424c42] to-[#647064]">
              <div>
                <font-awesome-icon :icon="['fas', 'fa-info']" class="w-6 h-6 text-white" />
              </div>
              <div class="font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis"> 
                {{ $t('titulo.editar.resumen.empresa') }}
              </div>
            </div>

            <div class="container p-4 text-left">
              <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
                <div class="w-full px-2">
                  <Editor v-model="formData.breveDescripcion" editorStyle="height: 320px">
                      <template v-slot:toolbar>
                        <span class="ql-formats">
                          <button v-tooltip.bottom="'Bold'" class="ql-bold"></button>
                          <button v-tooltip.bottom="'Italic'" class="ql-italic"></button>
                          <button v-tooltip.bottom="'Underline'" class="ql-underline"></button>
                        </span>
                      </template>
                    </Editor>
                </div>
              </div>
            </div>

            <div class="p-3 flex flex-col md:flex-row gap-2 justify-end w-full mt-5 bg-gray-100">
              <a @click="closeDialog(false)" class="cursor-pointer px-6 text-sm font-bold text-red-500 bg-transparent py-3 border border-red-500 shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                <font-awesome-icon :icon="['fas', 'fa-xmark']" /> {{ $t('boton.cancelar') }}
              </a>
              <a @click="aplicarCambios" class="cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                <font-awesome-icon :icon="['fas', 'fa-check-double']" /> {{ $t('boton.aplicar.cambios') }}
              </a>
            </div>
          </BlockUI>


        </div>
      </div>

    </div>
  </div>
</Teleport>  

</template>

<script lang="ts">
import { defineComponent } from 'vue';

import Swal from 'sweetalert2'
import Editor from 'primevue/editor';
import BlockUI from 'primevue/blockui';
import ProgressSpinner from 'primevue/progressspinner';

import { ConfiguracionMeeting, Empresa } from 'qreventos-suite/src/services/suite.interfaces';
import seguridadServices from '@/services/seguridad.services';
import configuracionMeetingService from '@/services/configuracion.merting.services';
import meetingService from 'qreventos-suite/meeting';

export default defineComponent({
  components: {
    Editor, BlockUI, ProgressSpinner
  },
  props: {
    closeFunction: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      blocked: false,
      empresa: undefined as unknown as Empresa,
      formData: {
        breveDescripcion: '',
      }
    };
  },
  methods: {
    closeDialog(reloadList: boolean = false) {
      if (this.closeFunction) {
        this.closeFunction(reloadList);
      }
    },
    limpiarHtml(html: string): string {
      if (!html) {
        return '';
      }
      return html
        .replace(/\s?style="[^"]*"/gi, '')
        .replace(/\s?class="[^"]*"/gi, '')
        .replace(/&nbsp;/gi, ' ')
        .trim();
    },
    async fillEmpresa() {
      const hash: string = seguridadServices.getLocalHash() as string;
      const configuracionMeeting:ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
      this.empresa = await meetingService.findEmpresaAcreditadoBy(configuracionMeeting.evento.id, hash);

      if (this.empresa) {        
        this.formData.breveDescripcion = this.empresa.breveDescripcion;
      }
    },
    async aplicarCambios() {
      try {
        this.blocked = true;

        const hash:string = seguridadServices.getLocalHash() as string;
        const configuracionMeeting:ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

        this.empresa.breveDescripcion = this.limpiarHtml(this.formData.breveDescripcion);
        this.formData.breveDescripcion = this.empresa.breveDescripcion?.replace(/<p>(&nbsp;|\s)*<\/p>/gi, '<p><br></p>');
        
        await meetingService.updateEmpresa(configuracionMeeting.evento.id, hash, this.empresa);
        
        this.closeDialog(true);
        
      }
      catch (error) {
        this.blocked = false;
        Swal.fire({ title: "Error", text: 'Error [' + error + ']', icon: "error" });
      } finally {
        this.blocked = false;
      }
    }, 
  },
  async mounted() {
    document.body.style.overflow = "hidden";
      try {        
        this.blocked = true;

        await this.fillEmpresa();

      } catch (error) {
        this.blocked = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.blocked = false;
      }    
    
  },
  unmounted() {
    document.body.style.overflow = "";
  }  
});
</script>